import type { ReactNode } from 'react';

interface SnippetLoaderProps {
  loading: boolean;
  error: string | null;
  children: ReactNode;
}

export default function SnippetLoader({ loading, error, children }: SnippetLoaderProps) {
  if (loading) {
    return (
      <div className="snippet-loader">
        <span className="loader-dot" />
        <span className="loader-dot" />
        <span className="loader-dot" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="snippet-error">
        <p className="error-message">{error}</p>
      </div>
    );
  }

  return <>{children}</>;
}
